import React from 'react'
import DatePicker from 'antd/lib/date-picker'
import ruRu from 'antd/es/date-picker/locale/ru_RU'
import {
  IconAngleLeft,
  IconAngleRight,
  IconAnglesLeft,
  IconAnglesRight,
  IconCalendar,
  IconCaretRightCircle,
} from '@utils/icons'

const { RangePicker } = DatePicker

const RangePickerUi: React.FC<any> = (props) => {
  return (
    <RangePicker
      style={{ width: '100%' }}
      {...props}
      locale={ruRu}
      suffixIcon={<IconCalendar width='1rem' height='1rem' fill='var(--color-arrows-date)' />}
      nextIcon={<IconAngleRight width='18' height='18' fill='var(--color-arrows-date)' />}
      prevIcon={<IconAngleLeft width='18' height='18' fill='var(--color-arrows-date)' />}
      superNextIcon={<IconAnglesRight width='18' height='18' fill='var(--color-arrows-date)' />}
      superPrevIcon={<IconAnglesLeft width='18' height='18' fill='var(--color-arrows-date)' />}
      separator={<IconCaretRightCircle width='18' height='18' fill='var(--color-main)' />}
      getPopupContainer={() => document.getElementById('App') || document.body}
    />
  )
}

export default RangePickerUi
